/**
 * @desc: - PT  密码修改弹窗
 * @param  {[FUNCTION]} ：close [关闭方法]  
 * @param  {[FUNCTION]} ：submit [提交方法]  
 * @param  {[BLOON]} ：display [是否显示]  
 * @param  {[string]} ：name [用户名]  
 * @author: vico
 */
 import React from 'react';

 export default class ResetPasswordAlert extends React.Component{
 	constructor(props){
 		super(props)
 		this.state={
 			password:''
 		}
 	}

 	componentWillReceiveProps(nextProps) {
 		if (!this.props.display && nextProps.display) {
 			this.setState({
 				password: ''
 			})
 		}
 	}

	//改变value值
	pasChange(event){
		this.setState({password:event.target.value})
	}

	handleSubmit(){
		const {submit} = this.props;
		submit(this.state.password)
	}

	render(){
		const {userName, display ,close, platform} =this.props;
		let _value= this.state.password;
		return(
			<div className={display ? 'resetAlert-box block' : 'hide'}>
				<h2 className="changeTitle">
					
					请重置您的{platform}登录密码
					<span>（PC端和手机端）</span>
					<a className="close-icon" onClick={close} title="关闭">X</a>
				</h2>
				
				<div className="tips">
					<i></i>
					<span>温馨提示 : </span>
					首次下载客户端的用户需要在平台官网{platform}游戏页面重置密码才可登录!
					</div>
				<div className="charge_input">
					<p>用户名：<span id="ptname">{userName}</span></p>
					<p>密　码：<input type="password" maxLength="8" onChange={this.pasChange.bind(this)} placeholder="请输入密码" value={_value}/></p>
				</div>
				<input type="button" value="提交" onClick={this.handleSubmit.bind(this)} className="change_btn"/>
			</div>
		)
	}
 }